module.exports = __webpack_public_path__ + "static/media/windows.9b20a7c8.svg";